import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";

//history
import history from "./_Utils/History";

//Paths
import { LOGIN, HOME, PROFILE, PIECHART, COFFEE, EDIT } from "./_Utils/Routes";

//Components
import NavBar from "./NavBar";
import Home from "./Home";
import Profile from "./Profile";
import FoodSection from "./FoodSection";
import Calculation from "./Calculation";
import UserStatistics from "./UserStatistics";
import Login from "./Login";

export default class RouterComponent extends Component {
  render() {
    return (
      <div className="Container">
        <Switch>
          {history.location.pathname !== "/Login" ? (
            <>
              <NavBar />
              <Route exact path={HOME} component={Home} />
              <Route exact path={PROFILE} component={Profile} />
              <Route exact path={PIECHART} component={UserStatistics} />
              <Route exact path={COFFEE} component={FoodSection} />
              <Route exact path={EDIT} component={Calculation} />
            </>
          ) : (
            <Route exact path={LOGIN} component={Login} />
          )}
        </Switch>
      </div>
    );
  }
}
